export default {
    bind(el, binding, vnode) {
        el.__clickoutside = ev => {
            var path =
                ev.path || (ev.composedPath ? ev.composedPath() : undefined);
            if (path ? path.indexOf(el) < 0 : !el.contains(ev.target)) {
                return binding.value.call(vnode.context, ev);
            }
        };
        document.addEventListener('click', el.__clickoutside, false);
    },
    unbind(el) {
        document.removeEventListener('click', el.__clickoutside, false);
        delete el.__clickoutside;
    }
};
